<template>
<div class="chapter">
<div class="inner_page">
<p class="h2b">Contents</p>
<p class="toc"><a href="#/html/9780226470986_07_ack">Acknowledgments</a></p>
<p class="toc"><a href="#/html/9780226470986_08_pref">Preface</a></p>
<p class="toc"><a href="#/html/9780226470986_09_ch1">1. Life, Death, and Time</a></p>
<p class="toc"><span href="#/html/9780226470986_10_ch2" title="Link target outside of Sample">2. The Power of Poetic Metaphor</span></p>
<p class="toc"><span href="#/html/9780226470986_11_ch3" title="Link target outside of Sample">3. The Metaphoric Structure of a Single Poem</span></p>
<p class="toc"><span href="#/html/9780226470986_12_ch4" title="Link target outside of Sample">4. The Great Chain of Being</span></p>
<p class="toc"><span href="#/html/9780226470986_13_con" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc"><span href="#/html/9780226470986_14_tra" title="Link target outside of Sample">More on Traditional Views</span></p>
<p class="toc"><span href="#/html/9780226470986_16_not" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/html/9780226470986_15_bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><a id="page_viii"></a><a id="page_ix"></a><span href="#/html/9780226470986_17_inmet" title="Link target outside of Sample">Indexes</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226470986_06_toc.vue?73ad0270